import { render, staticRenderFns } from "./UserRolesDialog.vue?vue&type=template&id=216ef23f"
import script from "./UserRolesDialog.vue?vue&type=script&lang=js"
export * from "./UserRolesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports